import React from 'react';
import { object, string } from 'yup';
import {
  Formik,
  Form,
} from 'formik';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';

import { useHttpStatus } from '~/commons/hooks';


import FormGroup from '~/commons/components/FormGroup.jsx';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';

const schema = object().shape({
  email: string()
    .email()
    .required(),
});
const defaults = {
  email: '',
};

const FormPwdResetMail = () => {
  const [res, req] = useHttpStatus();

  return (
    <>
      {res.status === 'success' ? (
        <div>
          <h2>
            <FA icon={faEnvelope} ></FA>
            &nbsp;
            已傳送
          </h2>
          <p>
            驗證電郵已發出
            <br />
            請按電郵中的指示驗證身分
          </p>
          <p>
            <strong>沒有收到電郵通知？</strong>
            <br />
            請聯絡本院技術支援部
          </p>
        </div>
      ) : (
        <Formik
          validationSchema={schema}
          initialValues={defaults}
          onSubmit={(values) => req({
            method: 'post',
            url: '/api/core/password/reset/mail',
            data: values,
          })}
        >
          <Form>
            <FormHttpAlert res={res} />
            <h2>忘記密碼?</h2>
            <p className="text-muted">
              我們可以協助你重設密碼
            </p>
            <p className="text-danger">
              <FA icon={faExclamationCircle} />
              &nbsp;
              注意：學生帳戶不能重設密碼
            </p>
            <FormGroup
              name="email"
              label="首先請輸入你的帳號電郵地址"
            />
            <div className="form-group text-right">
              <FormHttpBtn
                res={res}
                type="submit"
                className="btn-block btn-primary"
                icon={faPaperPlane}
              >
                傳送重設密碼電郵
              </FormHttpBtn>
            </div>
          </Form>
        </Formik>
      )}
    </>
  );
};

export default FormPwdResetMail;
